<label [style.width.px]="titleWidth">{{placeholder}}</label>
<div [class.wrap] = "multi === true" class="content" [ngStyle]="{ 'width' : 'calc( 100% - 15px - ' + titleWidth  + 'px )'}">
    <ng-content></ng-content>
</div>